import {Divider} from '@/components/ui/divider/Divider'
import {useTranslation} from '@/translations/i18n'
import {useDialogStore} from '@ariakit/react'
import {CreateProjectConfirmationDialog} from '../create-project-confirmation-dialog/CreateProjectConfirmationDialog'
import {CreateProjectFormSections} from '../create-project-form-sections/CreateProjectFormSections'
import {PageCardWrapper, PageContent} from '@/components/ui/page-atoms/PageAtoms'
import {CreateProjectUrlParams} from '@/features/projects/types'
import {useState} from 'react'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {CreateProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {ProjectFormHeading} from '../project-form-heading/ProjectFormHeading'
import {ScrollArea} from '@/components/ui/scroll-area/ScrollArea'
import {Scrollbar} from '@/components/ui/scrollbar/Scrollbar'
import {useFormContext} from 'react-hook-form'

export const CreateProjectFormCard = () => {
    const {t} = useTranslation()
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
    const {searchParams} = useParsedSearchParams(CreateProjectUrlParams)
    const confirmationModalStore = useDialogStore({
        open: isConfirmationModalOpen,
        setOpen: setIsConfirmationModalOpen
    })
    const {getValues} = useFormContext<CreateProjectFormValidationSchema>()

    return (
        <PageCardWrapper>
            <ProjectFormHeading
                title={t('projects:add_new_project')}
                schema={CreateProjectFormValidationSchema}
                showConfirmationModal={() => confirmationModalStore.setOpen(true)}
            />
            <Divider direction="horizontal" />
            <PageContent padding={0}>
                <ScrollArea style={{height: '100%'}} scrollbar={<Scrollbar />}>
                    <CreateProjectFormSections isOriginTreatmentRequest={searchParams.origin == 'treatment_request'} />
                </ScrollArea>
            </PageContent>
            {isConfirmationModalOpen && (
                <CreateProjectConfirmationDialog dialogStore={confirmationModalStore} defaultValues={getValues()} />
            )}
        </PageCardWrapper>
    )
}
